import { shopifyGidSchema, ShopifyIdType } from "@redotech/shopify-util/id";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export enum ShopifyCatalogStatusEnum {
  ACTIVE = "ACTIVE",
  ARCHIVED = "ARCHIVED",
  DRAFT = "DRAFT",
}
export const ShopifyCatalogStatusSchema = createEnum(ShopifyCatalogStatusEnum);

export const ShopifyCatalogIdSchema = z.union([
  shopifyGidSchema(ShopifyIdType.MarketCatalog),
  shopifyGidSchema(ShopifyIdType.AppCatalog),
  shopifyGidSchema(ShopifyIdType.CompanyLocationCatalog),
]);
export type ShopifyCatalogId = z.infer<typeof ShopifyCatalogIdSchema>;

const ShopifyListingPublicationSchema_ = z.object({
  id: z.string(),
  shopifyPublicationId: shopifyGidSchema(ShopifyIdType.Publication).nullable(),
  // We collapse the shopify catalog into its publication
  shopifyCatalogId: ShopifyCatalogIdSchema.nullable(),
  title: z.string(),
  status: ShopifyCatalogStatusSchema,
  publishedAt: z.date().nullable(),
});

export const ShopifyListingPublicationSchema: z.ZodType<ShopifyListingPublication> =
  ShopifyListingPublicationSchema_;
export interface ShopifyListingPublication
  extends z.infer<typeof ShopifyListingPublicationSchema_> {}

export type ShopifyListingPublicationWithoutRedoIds = Omit<
  ShopifyListingPublication,
  "id"
>;
